(function () {
  var currentObserver = null;
  var currentSentinel = null;

  function init() {
    var grid     = document.getElementById('product-grid');
    var sentinel = document.getElementById('insaura-scroll-sentinel');
    var spinner  = document.getElementById('insaura-scroll-spinner');

    if (!grid || !sentinel || sentinel === currentSentinel) return;

    currentSentinel = sentinel;
    if (currentObserver) currentObserver.disconnect();

    var loading = false;

    currentObserver = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      var nextUrl = grid.dataset.nextUrl;
      if (!nextUrl || loading) return;

      loading = true;
      if (spinner) spinner.style.display = 'block';

      fetch(nextUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser  = new DOMParser();
          var doc     = parser.parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid');

          if (newGrid) {
            Array.from(newGrid.children).forEach(function (item) {
              grid.appendChild(item);
            });
            grid.dataset.nextUrl = newGrid.dataset.nextUrl || '';
          }

          if (typeof window.insauraQsRebind === 'function') {
            window.insauraQsRebind();
          }
        })
        .catch(function (e) { console.error('Infinite scroll error:', e); })
        .finally(function () {
          loading = false;
          if (spinner) spinner.style.display = 'none';
        });
    }, { rootMargin: '200px' });

    currentObserver.observe(sentinel);
  }

  // Initial
  init();

  // Re-init when facets replace the product grid container content
  var container = document.getElementById('ProductGridContainer');
  if (container) {
    new MutationObserver(init).observe(container, { childList: true, subtree: false });
  }
})();
